import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductName } from 'situview-webapi-client';
import { ConfigService } from 'src/app/services/config.service';
import { SituReel, SituReelItem } from 'src/app/services/situ-reel.service';

@Component({
  selector: 'situ-reel-strip',
  templateUrl: './situ-reel-strip.component.html',
  styleUrls: ['./situ-reel-strip.component.scss']
})
export class SituReelStripComponent {
  @Input() reel: SituReel | undefined;
  @Input() selectedArtifactId: string | undefined;
  @Output() itemSelected = new EventEmitter<SituReelItem>();

  thumbnailFailed: { [artifactId: string]: boolean } = {};

  constructor(private configService: ConfigService) {}

  get sortedItems(): SituReelItem[] {
    if (!this.reel?.items) {
      return [];
    }
    return [...this.reel.items].sort((a, b) => a.displayOrder - b.displayOrder);
  }

  selectItem(item: SituReelItem) {
    if (!item?.artifactId || item.artifactId === this.selectedArtifactId) {
      return;
    }
    this.itemSelected.emit(item);
  }

  getThumbnailUrl(item: SituReelItem): string {
    if (item.thumbnailOverrideUrl) {
      return item.thumbnailOverrideUrl;
    }
    const base = this.configService.config.situViewWebApiBaseUrl;
    const thumbnailId = item.thumbnailArtifactId ?? item.artifactId;
    if (item.productName === ProductName.Facade) {
      return `${base}/home/GetImage?artifactId=${thumbnailId}&fileName=facade.jpg&width=512`;
    }
    if (item.productName === ProductName.ProductPreview) {
      return `${base}/home/GetImage?artifactId=${thumbnailId}&fileName=preview.webp`;
    }
    return `${base}/home/GetThumb?artifactId=${thumbnailId}`;
  }

  trackByArtifactId(_index: number, item: SituReelItem): string {
    return item.artifactId;
  }

  onThumbnailError(item: SituReelItem): void {
    this.thumbnailFailed[item.artifactId] = true;
  }

  getFallbackIcon(item: SituReelItem): string {
    switch (item.productName) {
      case ProductName.Facade: return 'home';
      case ProductName.Plan: return 'map';
      case ProductName.Render: return 'image';
      case ProductName.ProductPreview: return 'view_in_ar';
      default: return 'panorama';
    }
  }
}
